import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import { Spinner } from "react-bootstrap";
import HSAxios from "../HSAxios";
import { useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { MdOutlineMapsHomeWork } from "react-icons/md";
import { FaPlus, FaEdit, FaUpload } from "react-icons/fa";
import { Container } from "react-bootstrap";

export default function Hostellist() {
  let { hostelId } = useParams();
  const [hostelList, setHostelList] = useState([]);
  const [loading, setLoading] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const token = Cookies.get("token");

    if (!token) {
      console.log("Not logged in");
      navigate("/login", {});

      return;
    }

    HSAxios.get("api/owner/hostel").then((response) => {
      setHostelList(response.data);
      console.log("response data", response.data);
      console.log(hostelList);
      setLoading(false);
    });
  }, [navigate]);
  const handleImageUpload = (hostel) => {
    console.log(hostel);
    hostelId = hostel.hostel_id;
    console.log(hostelId);
    navigate(
      `/hostel/update/image/${hostelId}`,
      {
        state: {
          preview: true,
          hostelId: hostel.hostel_id,
        },
      },
      [hostelId]
    );
  };

  return (
    <>
      {loading && (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "70vh" }}>
          <Spinner
            animation="border"
            role="status"
            style={{
              width: "3rem",
              height: "3rem",
              borderWidth: "4px",
              borderColor: "#8B0000",
              borderRightColor: "transparent",
            }}
          />
          <p className="mt-4 fw-semibold" style={{ color: "#333", fontSize: "18px" }}>
            Loading hostels...
          </p>
        </div>
      )}
      {!loading &&
        (hostelList.length === 0 ? (
          <div
            className="container d-flex flex-column align-items-center justify-content-center"
            style={{ height: "85vh" }}
          >
            <div className="text-center">
              <div
                style={{
                  width: "120px",
                  height: "120px",
                  borderRadius: "50%",
                  backgroundColor: "#f8f9fa",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 30px",
                  border: "3px solid #e0e0e0",
                }}
              >
                <MdOutlineMapsHomeWork style={{ fontSize: "60px", color: "#8B0000" }} />
              </div>
              <h2 className="fw-bold mb-3" style={{ color: "#2A3D45" }}>
                No Hostels Found
              </h2>
              <p className="text-muted mb-4" style={{ fontSize: "18px" }}>
                It looks like you don't have any hostels registered yet!
              </p>
              <button
                className="btn fw-semibold px-5 py-3"
                onClick={() => navigate("/hostel/create")}
                style={{
                  backgroundColor: "#8B0000",
                  color: "white",
                  borderRadius: "12px",
                  fontSize: "16px",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 15px rgba(139, 0, 0, 0.3)",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#A00000";
                  e.target.style.transform = "translateY(-3px)";
                  e.target.style.boxShadow = "0 6px 20px rgba(139, 0, 0, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#8B0000";
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "0 4px 15px rgba(139, 0, 0, 0.3)";
                }}
              >
                Register Your First Hostel
              </button>
            </div>
          </div>
        ) : (
          <Container fluid style={{ padding: "40px 20px", minHeight: "calc(100vh - 200px)" }} className="hostellist-container">
            {/* Header Section */}
            <div
              className="hostellist-header"
              style={{
                backgroundColor: "white",
                borderRadius: "20px",
                padding: "30px 40px",
                marginBottom: "30px",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                border: "1px solid #f0f0f0",
              }}
            >
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div className="d-flex align-items-center gap-4 hostellist-header-content">
                  <div
                    className="hostellist-icon"
                    style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "16px",
                      background: "linear-gradient(135deg, #fff5f5 0%, #ffe0e0 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "2px solid #760B0B",
                      boxShadow: "0 4px 12px rgba(118, 11, 11, 0.15)",
                    }}
                  >
                    <MdOutlineMapsHomeWork style={{ fontSize: "32px", color: "#760B0B" }} />
                  </div>
                  <div>
                    <h2
                      className="fw-bold mb-1 hostellist-title"
                      style={{
                        color: "#760B0B",
                        fontSize: "36px",
                        letterSpacing: "1.5px",
                        textShadow: "0 2px 4px rgba(118, 11, 11, 0.1)",
                      }}
                    >
                      MY HOSTELS
                    </h2>
                    <p className="text-muted mb-0 hostellist-subtitle" style={{ fontSize: "15px", fontWeight: "500" }}>
                      Manage and update your hostel listings
                    </p>
                  </div>
                </div>
                <button
                  className="btn fw-semibold d-flex align-items-center gap-2 hostellist-register-btn"
                  onClick={() => navigate("/hostel/create")}
                  style={{
                    backgroundColor: "#10B981",
                    color: "white",
                    borderRadius: "12px",
                    padding: "12px 24px",
                    fontSize: "16px",
                    transition: "all 0.3s ease",
                    boxShadow: "0 4px 15px rgba(16, 185, 129, 0.3)",
                    border: "none",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#059669";
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow = "0 6px 20px rgba(16, 185, 129, 0.4)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#10B981";
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "0 4px 15px rgba(16, 185, 129, 0.3)";
                  }}
                >
                  <FaPlus style={{ fontSize: "18px" }} />
                  Register New Hostel
                </button>
              </div>
            </div>

            {/* Table Card */}
            <div
              className="hostellist-table-container"
              style={{
                backgroundColor: "white",
                borderRadius: "20px",
                padding: "30px",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                border: "1px solid #f0f0f0",
                overflow: "hidden",
              }}
            >
              <div className="hostellist-table-wrapper" style={{ width: "100%" }}>
                <Table
                  hover
                  className="hostellist-table"
                  style={{
                    marginBottom: "0",
                    borderCollapse: "separate",
                    borderSpacing: "0",
                    width: "100%",
                  }}
                >
                  <thead>
                    <tr
                      style={{
                        background: "linear-gradient(135deg, #760B0B 0%, #8B0000 100%)",
                        color: "white",
                      }}
                    >
                      <th
                        className="px-4 py-4 fw-bold table-header-cell"
                        style={{
                          border: "none",
                          fontSize: "15px",
                          letterSpacing: "0.5px",
                          textTransform: "uppercase",
                        }}
                      >
                        S.No
                      </th>
                      <th
                        className="px-4 py-4 fw-bold table-header-cell"
                        style={{
                          border: "none",
                          fontSize: "15px",
                          letterSpacing: "0.5px",
                          textTransform: "uppercase",
                        }}
                      >
                        Name
                      </th>
                      <th
                        className="px-4 py-4 fw-bold table-header-cell"
                        style={{
                          border: "none",
                          fontSize: "15px",
                          letterSpacing: "0.5px",
                          textTransform: "uppercase",
                        }}
                      >
                        Pincode
                      </th>
                      <th
                        className="px-4 py-4 fw-bold text-center table-header-cell"
                        style={{
                          border: "none",
                          fontSize: "15px",
                          letterSpacing: "0.5px",
                          textTransform: "uppercase",
                        }}
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {hostelList.map((hostel, index) => (
                      <tr
                        key={hostel.hostel_id}
                        className="hostellist-table-row"
                        style={{
                          transition: "all 0.3s ease",
                          borderBottom: "1px solid #f0f0f0",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#fff5f5";
                          e.currentTarget.style.transform = "scale(1.01)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "white";
                          e.currentTarget.style.transform = "scale(1)";
                        }}
                      >
                        <td
                          className="px-4 py-4 align-middle table-cell"
                          style={{
                            fontSize: "15px",
                            fontWeight: "600",
                            color: "#666",
                          }}
                        >
                          {index + 1}
                        </td>
                        <td
                          className="px-4 py-4 align-middle table-cell"
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#333",
                          }}
                        >
                          {hostel.name}
                        </td>
                        <td
                          className="px-4 py-4 align-middle table-cell"
                          style={{
                            fontSize: "15px",
                            color: "#666",
                          }}
                        >
                          {hostel.pincode}
                        </td>
                        <td className="px-4 py-4 align-middle table-cell">
                          <div className="d-flex gap-2 justify-content-center hostellist-action-buttons">
                            <Button
                              onClick={() => {
                                let hostelId = hostel.hostel_id;
                                navigate(`/hostel/update/${hostelId}`, {
                                  state: { hostelId: hostel.hostel_id },
                                });
                              }}
                              className="d-flex align-items-center gap-2 fw-semibold hostellist-edit-btn"
                              style={{
                                backgroundColor: "#760B0B",
                                borderColor: "#760B0B",
                                borderRadius: "10px",
                                padding: "8px 16px",
                                transition: "all 0.3s ease",
                                fontSize: "14px",
                                boxShadow: "0 2px 8px rgba(118, 11, 11, 0.2)",
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.backgroundColor = "#8B0000";
                                e.target.style.transform = "translateY(-2px)";
                                e.target.style.boxShadow = "0 4px 12px rgba(118, 11, 11, 0.4)";
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.backgroundColor = "#760B0B";
                                e.target.style.transform = "translateY(0)";
                                e.target.style.boxShadow = "0 2px 8px rgba(118, 11, 11, 0.2)";
                              }}
                            >
                              <FaEdit style={{ fontSize: "12px" }} />
                              EDIT
                            </Button>
                            <Button
                              onClick={() => handleImageUpload(hostel)}
                              className="d-flex align-items-center gap-2 fw-semibold hostellist-upload-btn"
                              style={{
                                backgroundColor: "#212529",
                                borderColor: "#212529",
                                borderRadius: "10px",
                                padding: "8px 16px",
                                transition: "all 0.3s ease",
                                fontSize: "14px",
                                boxShadow: "0 2px 8px rgba(33, 37, 41, 0.2)",
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.backgroundColor = "#000";
                                e.target.style.transform = "translateY(-2px)";
                                e.target.style.boxShadow = "0 4px 12px rgba(33, 37, 41, 0.4)";
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.backgroundColor = "#212529";
                                e.target.style.transform = "translateY(0)";
                                e.target.style.boxShadow = "0 2px 8px rgba(33, 37, 41, 0.2)";
                              }}
                            >
                              <FaUpload style={{ fontSize: "12px" }} />
                              UPLOAD
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </Container>
        ))}
    </>
  );
}
